<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <fin-select-box :items="itemList"
                      :label="label"
                      return-as-object
                      selectBoxItemTitle="name"
                      selectBoxItemValue="id"
                      @input="val => indexSelectionChanged(val)"
      />
    </template>
  </fin-data-loader>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import FinSelectBox from "@/components/common/SelectBox"

export default {
  name: "FinDataLoaderSelector",
  components: {FinSelectBox, FinDataLoader},
  props: {
    /** The resolver function which is called by the fin-data-loader */
    resolverFunction: {
      type: Function,
      required: true
    },
    /** The label of the select box */
    label: {
      type: String,
      required: true
    },
    /** Option to hide the given ids at the selector */
    excludeIds: {
      type: Array
    },
  },
  data() {
    return {
      itemList: [],
    }
  },
  methods: {
    async loadData() {
      let items = await this.resolverFunction()
      items = this.excludeIds && this.excludeIds.length > 0 ? items.filter(p => !this.excludeIds.includes(p.id)) : items
      this.itemList = items.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    },
    indexSelectionChanged(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style scoped>

</style>
